export function getDefaultScheduledEndTime(startTime: string) {
  if (!startTime) {
    return '09:00';
  }
  const hour = startTime.substring(0, 2);
  const minute = startTime.substring(3, 5);
  return `${Math.min(parseInt(hour) + 1, 23)}:${minute}`;
}
